// AddressInput.tsx
import React from 'react';
import {Button, HStack, Input} from "@chakra-ui/react";

interface AddressInputProps {
    address: string;
    setAddress: React.Dispatch<React.SetStateAction<string>>;
    lat: string;
    setLat: React.Dispatch<React.SetStateAction<string>>;
    lng: string;
    setLng: React.Dispatch<React.SetStateAction<string>>;
}

const AddressInput: React.FC<AddressInputProps> = ({
                                                       address,
                                                       setAddress,
                                                       lat,
                                                       setLat,
                                                       lng,
                                                       setLng,
                                                   }) => {
    const searchAddress = async () => {
        if (!address.trim()) {
            alert("Inserisci un indirizzo valido.");
            return;
        }
        try {
            const response = await fetch(
                `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
                    address
                )}`
            );
            const data = await response.json();
            if (data && data.length > 0) {
                // Usa il primo risultato della ricerca
                const {lat: foundLat, lon: foundLng} = data[0];
                setLat(foundLat);
                setLng(foundLng);
            } else {
                alert("Indirizzo non trovato!");
            }
        } catch (error) {
            console.error("Errore nella ricerca dell'indirizzo:", error);
            alert("Errore durante la ricerca dell'indirizzo");
        }
    };

    return (
        <div>
            {/* Campo per l'indirizzo e pulsante Cerca */}
            <HStack>
                <Input
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    _placeholder={{fontSize: 14}}
                    placeholder={"Inserisci indirizzo"}/>
                <Button onClick={searchAddress}>Cerca</Button>
            </HStack>

            <div style={{marginBottom: '10px', marginTop: '16px'}}>
                <p style={{marginRight: '10px'}}>
                    Latitudine:{'\n'}

                    <Input
                        inputMode={"text"}
                        colorScheme={"primary"}
                        variant='filled'
                        value={lat}
                        onChange={(e) => setLat(e.target.value)}
                        _placeholder={{fontSize: 14}}/>
                </p>
                <p style={{marginTop: '16px'}}>
                    Longitudine:{'\n'}

                    <Input
                        inputMode={"text"}
                        colorScheme={"primary"}
                        variant='filled'
                        value={lng}
                        onChange={(e) => setLng(e.target.value)}
                        _placeholder={{fontSize: 14}} />
                </p>
            </div>
        </div>
    );
};

export default AddressInput;
